import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import { FC, Fragment } from 'react';

import { useStore } from 'hooks/useStore';
import { capitalize } from 'utils/string/format';

import css from './FilterSummary.module.css';

const FilterSummary: FC = () => {
  const {
    savedFilters: { popup },
  } = useStore();

  if (!popup) return null;

  return (
    <div className={cn(css.summary, css.summary_disabled)}>
      {popup.summaryItems.map(item => (
        <Fragment key={item.type}>
          <div className={css.type}>{capitalize(item.type)}:</div>
          <div className={css.value}>{item.value}</div>
        </Fragment>
      ))}
    </div>
  );
};

const connected = observer(FilterSummary);

export { connected as FilterSummary };
